// const { PouchDB } = window;

class PouchDB {
  
}

export const ENABLE_API_CACHE = process.env.REACT_APP_ENABLE_API_CACHE === 'true';
export const TARGET_STORAGE = 'local_database';
export const LOCAL_DATABASE = localStorage.getItem(TARGET_STORAGE);

const CoreInterface = {
  get: async () => {},
  allDocs: async () => {},
  put: async () => {},
  post: async () => {},
  update: async () => {},
  remove: async () => {},
  putOrUpdate: async () => {}
};

export const Core = {
  // get by _id
  get: async (collection = PouchDB, _id = '') => {
    try {
      return await collection.get(_id);
    } catch(e) {
      return e;
    }
  },

  // get by document
  allDocs: async (collection = PouchDB, document = {
    include_docs: true
  }) => {
    try {
      return await collection.allDocs({ ...document, include_docs: true });
    } catch(e) {
      return e;
    }
  },

  find: async (collection = PouchDB, selector = {}) => {
    try {
      return await collection.find({ selector });      
    } catch (e) {
      return e;
    }
  },

  // create with automatically generated _id
  post: async (collection = PouchDB, document = {}) => {
    try {
      return await collection.post(document);
    } catch(e) {
      return e;
    }
  },

  // create with manual/custom _id to avoid duplicate
  put: async (collection = PouchDB, document = {
    _id: ''
  }) => {
    try {
      return await collection.put(document);
    } catch(e) {
      return e;
    }
  },

  // update when doc exists
  update: async (collection = PouchDB, document = {
    _id: ''
  }) => {
    try {
      const doc = await collection.get(document._id);
      return await collection.put({
        ...document,
        _rev: doc._rev
      });
    } catch(e) {
      return e;
    }
  },

  // remove by _id
  remove: async (collection = PouchDB, _id = '') => {
    try {
      const doc = await collection.get(_id);
      return await collection.remove(doc._id, doc._rev);
    } catch(e) {
      return e;
    }
  },

  // put or update a document
  putOrUpdate: async (collection = CoreInterface, document = {
    _id: ''
  }) => {
    const doc = await collection.put(document);

    if (doc && doc.error) {
      return await collection.update(document);
    }

    return doc;
  },
};

export const createModel = (pouch = PouchDB) => ({
  // get by _id
  get: Core.get.bind(this, pouch),
  // get by document
  allDocs: Core.allDocs.bind(this, pouch),
  // get by document
  find: Core.find.bind(this, pouch),
  // create with automatic _id
  post: Core.post.bind(this, pouch),
  // create with manual _id
  put: Core.put.bind(this, pouch),
  // update when doc exists
  update: Core.update.bind(this, pouch),
  // remove by _id
  remove: Core.remove.bind(this, pouch),
});

export const updateModelWithCustomQueries = (pouch = createModel(PouchDB)) => ({
  ...pouch,
  // create with manual _id or update when doc exists
  putOrUpdate: Core.putOrUpdate.bind(this, pouch),
});

export const createIndex = async (pouch = PouchDB, fields = []) => {
  try {
    const result = await pouch.createIndex({index: { fields }});
    return { error: false, result };
  } catch (message) {
    return { error: true, message };
  }
};

const db = {
  api: new PouchDB(LOCAL_DATABASE || 'hcp_api'),
};

// api model
createIndex(db.api, ['url']);
export const api = updateModelWithCustomQueries(createModel(db.api));
